// 1. รวบรวมสถานะและคำอธิบายเป็น Array เพื่อนำไปลูปใช้งาน
export const withdrawStatuses = [
    { key: "IN_QUEUE", },
    { key: "PROCESSING" },
    { key: "REQUESTING" },
    { key: "SUCCESS" },
    { key: "REJECTED",},
    { key: "INQ_MANUAL",}
];


export const verifyslipStatuses = [
    { key: "DUPLICATED",},
    { key: "NOT_MATCH",},
    { key: "MATCHED",},
    { key: "SUCCESS",},
];

export const CustomerStatuses = [
    { key: "Active",},
    { key: "PENDING",},
];